import React from 'react';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import { formatPhone } from 'utils/formatPhone';
import mobile from './banner_mobile.png';
import desktop from './banner_desktop.png';

const ShopInfo = () => {
  const shopInfo = shopSelectors.getShopInfo();

  return (
    <Container className='ShopInfo'>
      <ResponsiveBanner
        $banner={shopInfo?.bannerUrl || desktop}
        $mobile={shopInfo?.thumbnail || mobile}
        alt='banner_image'
      />
      <div className='detail-box'>
        <div className='title'>{shopInfo?.shopName || ''}</div>
        <p className='info'>{shopInfo?.address || '--'}</p>
        <p className='info'>
          {[shopInfo?.city, shopInfo?.state, shopInfo?.zip].filter((o) => !!o).join(', ')}
        </p>
        <p className='info'>{formatPhone(shopInfo?.phone || '')}</p>
      </div>
    </Container>
  );
};

export default ShopInfo;

const Container = styled.div`
  margin-bottom: 24px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  .detail-box {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(15px);
    opacity: 0.8;
    padding: 1rem 1rem;
    border-radius: 8px;
    background: rgba(45, 103, 114, 0.8);
  }

  .title {
    color: #fff;
    text-align: center;
    font-family: Poller One;
    font-size: 1.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .info {
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  @media only screen and (max-width: 900px) {
    .detail-box {
      width: 80%;
      svg {
        width: 30%;
      }
      .title {
        font-size: 16px;
      }
      .info {
        font-size: 13px;
        padding: 0 8px;
      }
    }
  }
`;

const ResponsiveBanner = styled.img<{ $banner: string; $mobile: string }>`
  width: 100%;
  height: 250px;
  object-fit: cover;
  content: url(${({ $banner }) => $banner});
  @media only screen and (max-width: 900px) {
    content: url(${({ $mobile }) => $mobile});
  }
`;
